// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__Lr9ag","label":"Input_label__4jXv2","input":"Input_input__fuYil"};